import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from '@/environments/environment';
import { permitSynchronizeModel } from '@/app/interfaces/permitSynchronize';

@Injectable({
  providedIn: 'root',
})
export class PermitSynchronizeService {
  synchronizeSolutionPermissions(orgCode?: string): void {
    const payload: permitSynchronizeModel = {
      syncType: 'solution',
      params: {
        orgCode: orgCode ?? this.getUserOrgCode(),
      },
    };

    this.postSynchronizePermissions(payload);
  }

  // No es asincrona porque nos da igual lo que devuelva, no queremos parar el flujo de la aplicación
  synchronizePermissions(
    orgCode?: string,
    jobCode?: string,
    responsibleEmail?: string,
    previousResponsibleEmail?: string,
    orgCodeResponsible?: string,
    synchronizeCreateInAddition?: boolean
  ): void {
    const loggedEmail = this.getUserEmail();
    const payload: permitSynchronizeModel = {
      syncType: 'workflow',
      params: {
        orgCode: orgCode ?? this.getUserOrgCode(),
        jobCode: jobCode ?? this.getUserJobCode(),
        orgCodeResponsible: orgCodeResponsible ?? null,
      },
    };
    let shouldSynchronizeCreate = false;

    if (responsibleEmail && previousResponsibleEmail) {
      // Si el email del responsable ha cambiado en project-correction
      if (responsibleEmail !== previousResponsibleEmail) {
        shouldSynchronizeCreate = true;
      }
    }
    if (responsibleEmail) {
      // Si el email del responsable no coincide con el del creador (para new-project y new-system)
      if (loggedEmail && responsibleEmail !== loggedEmail) {
        shouldSynchronizeCreate = true;
      }
    }
    if (shouldSynchronizeCreate && !synchronizeCreateInAddition) {
      payload.syncType = 'create';
    }

    this.postSynchronizePermissions(payload);

    if (shouldSynchronizeCreate && synchronizeCreateInAddition) {
      const createPayload: permitSynchronizeModel = {
        ...payload,
        syncType: 'create',
      };

      this.postSynchronizePermissions(createPayload);
    }
  }

  private postSynchronizePermissions(payload: permitSynchronizeModel): void {
    void axios
      .post(`${environment.url}/api/anjana/sincronizar_permisos`, payload, { withCredentials: true })
      .catch(() => undefined);
  }

  // Funcion para sacar el orgCode del usuario desde localStorage
  private getUserOrgCode(): string | null {
    const rawUserData = localStorage.getItem('userData');
    if (!rawUserData) {
      return null;
    }
    try {
      const parsedUserData = JSON.parse(rawUserData);
      return parsedUserData?.orgCode ?? null;
    } catch {
      return null;
    }
  }

  // Funcion para sacar el jobCode del usuario desde localStorage
  private getUserJobCode(): string | null {
    const rawUserData = localStorage.getItem('userData');
    if (!rawUserData) {
      return null;
    }
    try {
      const parsedUserData = JSON.parse(rawUserData);
      return parsedUserData?.roleCode ?? null;
    } catch {
      return null;
    }
  }

  // Funcion para sacar el email del usuario logeado
  private getUserEmail(): string | null {
    const rawUserData = localStorage.getItem('userData');
    if (!rawUserData) {
      return null;
    }
    try {
      const parsedUserData = JSON.parse(rawUserData);
      return parsedUserData?.email ?? null;
    } catch {
      return null;
    }
  }
}
